<template>
      <!-- banner area start -->
    <div class="banner-area jarallax" style="background-image: url(/img/anibi.png);">
        <div class="container">
            <div class="banner-inner-wrap">
                <div class="row">
                    <div class="col-lg-10">
                        <div class="banner-inner">
                            <h5 class="sub-title">Built With Sructure</h5>
                            <h1 class="title">Modern New Apartment In Residential Complex</h1>
                            <div class="banner-btn-wrap">
                                <a class="btn btn-yellow mr-2" href="/property">CHECK PROPERTIES</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- banner area end -->
</template>

<script>
export default {
  name: "LargeBanner",
  
};
</script>


<style>

</style>



    